export default __webpack_public_path__ + "static/media/smiles-logo-text.9a764327.svg";